import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import "./index.less";
import { Resource } from "@/types/resource";
import DownloadList from "../DownloadList";
import { isOwnProperty } from "@/utils/common";
import { Button } from "antd";
import { ResourceDetailContext } from ".";

const prefix = "resource-detail";

const resourceTypeNames: any = {
  GUIDE: "指导书",
  DEVELOP: "开发工具",
  SOFTWARE: "软件包",
};

export const SelectContext = React.createContext<any>({});

const ResourceDownloadCard = (props: any) => {
  const { versionTypeList } = props;
  return (
    <div className={`${prefix}-content-version-list`}>
      {versionTypeList?.map((item: Resource.ResourceType, index: number) => {
        return <ResourceDownloadCardItem item={item} key={item.name} />;
      })}
    </div>
  );
};

const ResourceDownloadCardItem = (props: { item: Resource.ResourceType }) => {
  const { item } = props;
  // console.log("ResourceDownloadCardItem", item);

  const [isShowAll, setShowAll] = useState(false); //展示全部
  const [isDownloadAll, setIsDownloadAll] = useState(false); //下载全部
  const [ResourceList, setResourceList] = useState<any>([]); //下载列表
  const [downloadAllLoading, setDownloadAllLoading] = useState(false); //下载全部loading
  const { downloadOneResourceEvent, downloadSelectResourceEvent } = useContext(ResourceDetailContext);
  useEffect(() => {
    setResourceList(selectAll(item.resourceDetails));
  }, [item]);
  /**
   * 全选
   * @param list
   * @returns
   */
  const selectAll = (list: any[]) => {
    return list.map((resource: Resource.ResourceDetail) => {
      const hasSku = isOwnProperty(resource, "skuList") && resource.skuList;
      const data = {
        ...resource,
        isSelect: resource.urlType == Resource.ResourceUrlType.DOWNLOAD,
      };
      if (hasSku) {
        data.skuList = data.skuList?.map((sku: Resource.skuListType, index) => {
          return {
            ...sku,
            isSelect: true,
            id: resource.id + "-" + sku.id,
          };
        });
      }
      return data;
    });
  };
  const changeSelect = useCallback(
    /**
     * 更改选中状态
     * @param selectId
     */
    (selectId: string) => {
      console.log("changeSelect", selectId);
      setResourceList((val: any) =>
        val.map((item: Resource.ResourceDetail) => {
          const resource = {
            ...item,
          };
          if (selectId.includes("-")) {
            const [id, skuIndex] = selectId.split("-");
            if (resource.id === id) {
              resource.skuList = resource.skuList?.map((sku: Resource.skuListType, index) => {
                return {
                  ...sku,
                  isSelect: sku.id === selectId ? !sku.isSelect : sku.isSelect,
                };
              });
              resource.isSelect = resource.skuList?.some((sku: Resource.skuListType) => {
                return sku.isSelect;
              });
            }
          } else {
            if (resource.id === selectId) {
              resource.isSelect = !resource.isSelect;
              if (resource.skuList) {
                resource.skuList = resource.skuList?.map((sku: Resource.skuListType) => {
                  return {
                    ...sku,
                    isSelect: resource.isSelect,
                  };
                });
              }
            }
          }
          return resource;
        })
      );
    },
    []
  );
  const downloadHandle = useCallback(
    /**
     * 下载资源
     * @param id
     */
    (id: string) => {
      downloadOneResourceEvent(id);
    },
    []
  );

  const onDownloadAllHandle = useCallback(
    /**
     * 下载全部
     */
    () => {
      setDownloadAllLoading(true);
      const list: any[] = [];
      ResourceList.forEach((item: Resource.ResourceDetail) => {
        if (item.skuList) {
          return item.skuList.forEach((sku: Resource.skuListType) => {
            if (sku.isSelect) {
              list.push(sku.id.split("-")[1]);
            }
          });
        }
        if (item.isSelect) {
          list.push(item.id);
        }
      });
      downloadSelectResourceEvent(list, () => setDownloadAllLoading(false));
    },
    [ResourceList]
  );
  const showAll = () => {
    setShowAll((val) => !val);
  };
  const cancelDownloadAll = () => {
    setIsDownloadAll(false);
  };
  const showDownloadAll = () => {
    setResourceList(selectAll(item.resourceDetails));
    setIsDownloadAll(true);
  };
  const isNeedShowAll = item.resourceDetails.length > 6;

  const downloadList = useMemo(
    /**
     * 资源列表
     * @returns
     */
    () => {
      return isShowAll ? ResourceList : ResourceList.slice(0, 6);
    },
    [isShowAll, ResourceList]
  );
  const selectDownloadCount = useMemo(
    /**
     * 选中的下载数量
     * @returns
     */
    () => {
      let count = 0;
      ResourceList.forEach((item: Resource.ResourceDetail) => {
        if (item.skuList) {
          return item.skuList.forEach((sku: Resource.skuListType) => {
            if (sku.isSelect) {
              count++;
            }
          });
        }
        if (item.isSelect) {
          count++;
        }
      });
      return count;
    },
    [ResourceList]
  );
  const showAllText = isShowAll ? "收起" : "展开全部";
  return (
    <div className={`${prefix}-content-version-list-item`} key={item.name}>
      <div className={`${prefix}-content-version-list-item-title`}>
        <div className="left-text">
          <div>
            <img src={require(`@/assets/images/freedownload/${item.name}.png`)} alt="" />
          </div>
          {resourceTypeNames[item.name]}
        </div>
        <div className="right-download">
          {isDownloadAll ? (
            <div>
              <span onClick={cancelDownloadAll}>取消</span>
              <Button loading={downloadAllLoading} type="primary" onClick={onDownloadAllHandle} disabled={selectDownloadCount === 0}>
                下载({selectDownloadCount})
              </Button>
            </div>
          ) : (
            <span onClick={showDownloadAll}>下载全部</span>
          )}
        </div>
      </div>
      <SelectContext.Provider
        value={{
          isDownloadAll,
          changeSelect,
        }}
      >
        <DownloadList data={downloadList} downloadHandle={downloadHandle} />
      </SelectContext.Provider>

      {isNeedShowAll && (
        <div className={`${prefix}-more flex-center`}>
          <span onClick={showAll}>{showAllText}</span>
          <span onClick={showAll} className={`${prefix}-more-arrow ${isShowAll ? "up" : "down"}`}></span>
        </div>
      )}
    </div>
  );
};

export default React.memo(ResourceDownloadCard);
